/* eslint-disable comma-dangle */
/* eslint-disable operator-linebreak */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import {
  Card,
  CardAction,
  CardContent,
  CardImages,
  CardRow,
  Container,
  Icon,
  OnPress,
  SubTitleCard,
  TitleCard,
  ListDrop,
  Margin,
} from './styles';
import axios from '../../services/axiosServicesAgendamentos';
import CardContainerCommon from '../../components/cardCommon';
import icons from '../../constants/icons';
import MyLoader from '../../components/placeholderCommon';
import NavCommon from '../../components/navCommon';
import ItemDrop from '../../components/itemListDropCommon';

const Polepositions = (props: any) => {
  const [dataToPage, setDataToPage] = useState<Array<any> | null>(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [openDrop, setOpenDrop] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const params: {
        PaginaAtual: number;
        TotalItensRetorno: number;
      } = {
        PaginaAtual: 1,
        TotalItensRetorno: 20,
      };
      setLoading(true);
      const respose = await axios.get('admin/pole-position/v1', { params });
      setDataToPage(respose.data.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      if (error?.status !== 500) {
        toast.error(
          'Atenção, não foi possível carregar os dados do poleposition!'
        );
      }
    }
  };

  const Body = () => (
    <>
      <Container>
        {loading ? (
          <Margin>
            <MyLoader />
          </Margin>
        ) : null}
        {!loading &&
          dataToPage &&
          dataToPage.map((item: any) => (
            <Card key={item.idPolePosition}>
              <CardAction>
                <CardImages
                  // @ts-ignore
                  component="img"
                  height="188"
                  image={item.urlImagem}
                  alt="Imagem Pole"
                />
                <CardContent>
                  <CardRow>
                    <TitleCard>{item.nome}</TitleCard>
                    <OnPress
                      onClick={() => {
                        props.history.push('/editar-polepositions', {
                          polepositionId: item.idPolePosition,
                          poleName: item.nome,
                          criterionsPole: item.criterios,
                          placesPole: item.locais,
                        });
                      }}
                    >
                      <Icon height={16} width={18} src={icons.editIcon} />
                    </OnPress>
                  </CardRow>
                  <SubTitleCard>{item.descricaoBeneficio}</SubTitleCard>
                </CardContent>
              </CardAction>
            </Card>
          ))}
      </Container>
    </>
  );

  const ListToDrop = (): any => (
    <div>
      <ItemDrop
        onPress={() => history.push('/criterios-poleposition')}
        name="Critérios"
      />
      <ItemDrop
        onPress={() => history.push('/importar-planilha-poleposition')}
        name="Importar arquivo"
      />
      <ItemDrop onPress={() => history.push('/ranking')} name="Ranking" />
    </div>
  );

  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: '/polipositions', name: 'Pole positions' }]}
        showDrop
        hasOnChange
        onBack={() => {
          history.goBack();
        }}
        setOpen={setOpenDrop}
        open={openDrop}
        options={ListToDrop()}
        onChange={() => history.push('/novo-poleposition')}
      />
      <CardContainerCommon
        title="Pole positions"
        childrens={Body()}
        hasFilter={false}
      />
    </>
  );
};
export default Polepositions;
